export class OutletAcquisitionType {
    ID: number;
    Name: string;
    Inactive: boolean;
}

export default OutletAcquisitionType;